import axios from 'axios'
import {
  USER_ACTIVATE_FAIL,
  USER_ACTIVATE_REQUEST,
  USER_ACTIVATE_SUCCESS,
  USER_ADMIN_COMPLETE_SIGNUP_FAIL,
  USER_ADMIN_COMPLETE_SIGNUP_REQUEST,
  USER_ADMIN_COMPLETE_SIGNUP_SUCCESS,
  USER_ADMIN_LIST_FAIL,
  USER_ADMIN_LIST_REQUEST,
  USER_ADMIN_LIST_SUCCESS,
  USER_ADMIN_UPDATE_INFO_FAIL,
  USER_ADMIN_UPDATE_INFO_REQUEST,
  USER_ADMIN_UPDATE_INFO_SUCCESS,
  USER_CONFIRM_VALIDATION_FAIL,
  USER_CONFIRM_VALIDATION_REQUEST,
  USER_CONFIRM_VALIDATION_SUCCESS,
  USER_DEACTIVATE_FAIL,
  USER_DEACTIVATE_REQUEST,
  USER_DEACTIVATE_SUCCESS,
  USER_DELETE_FAIL,
  USER_DELETE_REQUEST,
  USER_DELETE_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_RESET,
  USER_DETAILS_SUCCESS,
  USER_INVITE_FAIL,
  USER_INVITE_REQUEST,
  USER_INVITE_SUCCESS,
  USER_LIST_FAIL,
  USER_LIST_REQUEST,
  USER_LIST_RESET,
  USER_LIST_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_RESET_PASSWORD_FAIL,
  USER_RESET_PASSWORD_LINK_FAIL,
  USER_RESET_PASSWORD_LINK_REQUEST,
  USER_RESET_PASSWORD_LINK_SUCCESS,
  USER_RESET_PASSWORD_REQUEST,
  USER_RESET_PASSWORD_SUCCESS,
  USER_UPDATE_INFO_FAIL,
  USER_UPDATE_INFO_REQUEST,
  USER_UPDATE_INFO_SUCCESS,
  USER_UPDATE_PASSWORD_FAIL,
  USER_UPDATE_PASSWORD_REQUEST,
  USER_UPDATE_PASSWORD_SUCCESS,
} from '../constants/userConstants'

export const login = (email, password, rememberMe) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    })

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const { data } = await axios.post(
      '/api/users/login',
      { email, password, rememberMe },
      config
    )

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    })

    if (rememberMe) {
      localStorage.setItem('userInfo', JSON.stringify(data))
    } else {
      sessionStorage.setItem('userInfo', JSON.stringify(data))
      localStorage.setItem('userInfo', '')
    }
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const logout = () => (dispatch) => {
  localStorage.removeItem('userInfo')
  sessionStorage.removeItem('userInfo')

  dispatch({ type: USER_LOGOUT })
  dispatch({ type: USER_DETAILS_RESET })
  dispatch({ type: USER_LIST_RESET })
}

export const register =
  (firstName, lastName, email, password, marketingConsent) =>
  async (dispatch) => {
    try {
      dispatch({
        type: USER_REGISTER_REQUEST,
      })

      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      const { data } = await axios.post(
        '/api/users',
        { firstName, lastName, email, password, marketingConsent },
        config
      )

      dispatch({
        type: USER_REGISTER_SUCCESS,
        payload: data,
      })
    } catch (error) {
      dispatch({
        type: USER_REGISTER_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const inviteAdmin = (user) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    dispatch({
      type: USER_INVITE_REQUEST,
    })

    const { data } = await axios.post('/api/users/invite', user, config)

    dispatch({
      type: USER_INVITE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_INVITE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const inviteCustomer = (user) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    dispatch({
      type: USER_INVITE_REQUEST,
    })

    const { data } = await axios.post(
      '/api/users/invite-customer',
      user,
      config
    )

    dispatch({
      type: USER_INVITE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_INVITE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getUserDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DETAILS_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/users/${id}`, config)

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getInviteUserDetails = (id) => async (dispatch) => {
  try {
    dispatch({
      type: USER_DETAILS_REQUEST,
    })

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const { data } = await axios.get(`/api/users/invited-user/${id}`, config)

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updateUserInfo = (user) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_UPDATE_INFO_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(`/api/users/${userInfo._id}`, user, config)

    dispatch({
      type: USER_UPDATE_INFO_SUCCESS,
      payload: data,
    })

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    })

    localStorage.setItem('userInfo', JSON.stringify(data))
  } catch (error) {
    dispatch({
      type: USER_UPDATE_INFO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updateAdminUserInfo = (user) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_ADMIN_UPDATE_INFO_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `/api/users/admin/${userInfo._id}`,
      user,
      config
    )

    dispatch({
      type: USER_ADMIN_UPDATE_INFO_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_ADMIN_UPDATE_INFO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const completeAdminUserSignUp = (user) => async (dispatch) => {
  try {
    dispatch({
      type: USER_ADMIN_COMPLETE_SIGNUP_REQUEST,
    })

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const { data } = await axios.put(
      `/api/users/complete-admin-sign-up`,
      user,
      config
    )

    dispatch({
      type: USER_ADMIN_COMPLETE_SIGNUP_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_ADMIN_COMPLETE_SIGNUP_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const listUsers = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_LIST_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/users/list`, config)

    dispatch({
      type: USER_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const listAdminUsers = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_ADMIN_LIST_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/users/admin-list`, config)

    dispatch({
      type: USER_ADMIN_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_ADMIN_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const deleteUser = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DELETE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    await axios.delete(`/api/users/${id}`, config)

    dispatch({ type: USER_DELETE_SUCCESS })
  } catch (error) {
    dispatch({
      type: USER_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const confirmUserEmail = (confirmationCode) => async (dispatch) => {
  try {
    dispatch({
      type: USER_CONFIRM_VALIDATION_REQUEST,
    })

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const { data } = await axios.post(
      `/api/users/confirm`,
      { confirmationCode },
      config
    )

    dispatch({
      type: USER_CONFIRM_VALIDATION_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_CONFIRM_VALIDATION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const resetUserPassword =
  (password, confirmationCode) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_RESET_PASSWORD_REQUEST,
      })

      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      const { data } = await axios.post(
        `/api/users/reset-password`,
        { password, confirmationCode },
        config
      )

      dispatch({
        type: USER_RESET_PASSWORD_SUCCESS,
        payload: data,
      })
    } catch (error) {
      dispatch({
        type: USER_RESET_PASSWORD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const generatePasswordResetLink =
  (email) => async (dispatch, getState) => {
    const {
      userLogin: { userInfo },
    } = getState()

    try {
      dispatch({
        type: USER_RESET_PASSWORD_LINK_REQUEST,
      })

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.put(
        `/api/users/reset-password-link`,
        { email, user: userInfo },
        config
      )

      dispatch({
        type: USER_RESET_PASSWORD_LINK_SUCCESS,
        payload: data.confirmationCode,
      })
    } catch (error) {
      dispatch({
        type: USER_RESET_PASSWORD_LINK_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const updateUserPassword =
  (password, newPassword, id) => async (dispatch, getState) => {
    const {
      userLogin: { userInfo },
    } = getState()

    try {
      dispatch({
        type: USER_UPDATE_PASSWORD_REQUEST,
      })

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.post(
        `/api/users/update-password`,
        { password, newPassword, id },
        config
      )

      dispatch({
        type: USER_UPDATE_PASSWORD_SUCCESS,
        payload: data,
      })
    } catch (error) {
      dispatch({
        type: USER_UPDATE_PASSWORD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const deactivateUser = (user) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DEACTIVATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `/api/users/deactivate/${user._id}`,
      user,
      config
    )

    dispatch({
      type: USER_DEACTIVATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_DEACTIVATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const activateUser = (user) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_ACTIVATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `/api/users/activate/${user._id}`,
      user,
      config
    )

    dispatch({
      type: USER_ACTIVATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_ACTIVATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
